import { render, staticRenderFns } from "./NetworkSwtichModal.vue?vue&type=template&id=bb133ecc&scoped=true&lang=pug&"
import script from "./NetworkSwtichModal.vue?vue&type=script&lang=ts&"
export * from "./NetworkSwtichModal.vue?vue&type=script&lang=ts&"
import style0 from "./NetworkSwtichModal.vue?vue&type=style&index=0&id=bb133ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb133ecc",
  null
  
)

export default component.exports